import * as React from 'react'
import * as firebase from 'firebase/app'
import 'firebase/firestore'

class MilestoneState {
    public cakeDay: number = 0
    public isFirstClass: boolean = false
    public streak: number = 0
    public isChickenDay: boolean = false;
}

class MilestoneProps {
    public userId: string
    public classId: string
    public participantId: string
}

class Milestone extends React.Component<MilestoneProps, MilestoneState> {

    private mileStoneListenerTask: firebase.Unsubscribe

    constructor(props: MilestoneProps) {
        super(props)
        this.state = new MilestoneState()
    }

    public componentWillMount() {
        const nextState = new MilestoneState()
        this.mileStoneListenerTask = firebase.firestore().collection('users').doc(this.props.userId).onSnapshot(snapshot => {
            // calculate birthday
            const today = new Date()
            const createdDate = snapshot.data()!.createdDate.toDate()
            const streak = snapshot.data()!.streak
            if (today.getDate() === createdDate.getDate() && today.getMonth() === createdDate.getMonth()) {
                nextState.cakeDay = today.getFullYear() - createdDate.getFullYear()
            }

            if (streak !== undefined && streak >= 3) {
                nextState.streak = streak
            }
            this.setState(nextState)
        })
        firebase.firestore().collection('classes').doc(this.props.classId).collection('students').doc(this.props.participantId).onSnapshot(snapshot => {
            const flag = snapshot.data()!.isFirstClass
            if (flag === undefined) {
                nextState.isFirstClass = false
            } else {
                nextState.isFirstClass = flag
            }

            nextState.isChickenDay = snapshot.data()!.isChickenDay;

            this.setState(nextState)
        })
        this.setState(nextState)
    }

    public componentWillUnmount() {
        this.mileStoneListenerTask()
    }

    public render() {
        let cakes = '';
        let chickenEmoji = '';
        let streak = '';
        if (this.state.cakeDay > 0) {
            cakes = '🎂';
        }

        if (this.state.isChickenDay) {
            chickenEmoji = '🐣';
        }

        if (this.state.streak >= 3) {
            streak = `🔥(${this.state.streak})`
        }
        return (<span>{cakes}{chickenEmoji}{streak}</span>)
    }
}

export default Milestone


// WEBPACK FOOTER //
// ./src/components/stream/students/Milestone/Milestone.tsx